import Image from 'next/image';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { DEFAULT_FLAG } from '../../../Assets/images';
import DropdownStyled from './DropdownStyled';
import { isRTL } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../../../i18n';

const DropdownControl = (props) => {
  const [isHover, setIsHover] = useState(false);
  const [currentLang, setCurrentLanguage] = useState('');

  useEffect(() => {
    if(window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);

  return (
    <DropdownStyled
      className={`${props.appVariant} ${props.enableFullWidth && 'fullWidth'} ${currentLang && isRTL(currentLang) ? 'rtl' : ''}`}
      isHeaderDropdown={props?.theme}
    >
      {props.label && <label className="form-label">{props.label}</label>}
      {(() => {
        if (props?.renderDropdownItem) {
          return (
            <Dropdown className={props.theme} onSelect={props.handleSelect}>
              <Dropdown.Toggle id="dropdown-custom-components" disabled={props?.disabled} name={props?.name}>
                {props?.caption}
              </Dropdown.Toggle>
              <Dropdown.Menu>{props?.renderDropdownItem(props?.data)}</Dropdown.Menu>
            </Dropdown>
          );
        } else if (props?.theme === 'dobdropdown') {
          return (
            <Dropdown onSelect={props.handleSelect} className={`dob-dropdown ${props?.countryClass}`}>
              <Dropdown.Toggle id="dropdown-custom-components" disabled={props?.disabled} name={props?.name}>
                {props?.selected ? props?.selected : <span className="grey-text">{props?.caption}</span>}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {(() => {
                  if (props?.data?.length > 0) {
                    return props?.data?.map((item) => {
                      return (
                        <div className="dropdown-menu-item" key={item?.text}>
                          <Dropdown.Item data-test="dropdown-item" eventKey={item?.text}>
                            <div className="text ">{item?.text}</div>
                          </Dropdown.Item>
                        </div>
                      );
                    });
                  } else {
                    return (
                      <Dropdown.Item eventKey="1" className="noData">
                        No Data
                      </Dropdown.Item>
                    );
                  }
                })()}
              </Dropdown.Menu>
            </Dropdown>
          );
        } else if (props?.theme === 'regionLanguageDropdown') {
                    return (
            <Dropdown onSelect={props.handleSelect} className={`country-dropdown ${currentLang && isRTL(currentLang) ? 'rtl' : ''} ${props?.countryClass}`}>
              <Dropdown.Toggle id="dropdown-custom-components" disabled={props?.disabled} name={props?.name}>
                {props?.caption}
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ width: "160px", height: "160px"}}>
                {props?.data?.length > 0 ? (
                  props?.data.map((item, i) => (
                    <div className="dropdown-menu-item" key={i} style={{ textAlign: 'center'}}>
                      <Dropdown.Item
                        data-test="dropdown-item"
                        eventKey={item?.regionName}
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                        style={{ paddingTop: "8px", paddingBottom: 0 }}
                      >
                        <div className="region-language-dropdown" style={{display: "flex", alignItems: "center", gap: "8px"}}>
                          <div className="ic">
                            <Image
                              src={item?.flagImage || DEFAULT_FLAG.src}
                              height={"24px"}
                              width={"32px"}
                              alt=""
                            />
                          </div>
                          <div style={{textAlign: "left"}}>
                            <div style={{color: isHover ?'#ffffff':'#31363c'}} className='region'>{item.region}</div>
                          </div>
                        </div>
                      </Dropdown.Item>
                      {i < props?.data.length - 1 && <Dropdown.Divider className="my-0" />}
                    </div>
                  ))
                ) : (
                  <Dropdown.Item eventKey="1" className="noData">
                    No Data
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          );
        } else if (props?.theme === 'countryDropdown') {
          return (
            <Dropdown onSelect={props.handleSelect} className={`country-dropdown ${props?.countryClass}`}>
              <Dropdown.Toggle id="dropdown-custom-components" disabled={props?.disabled} name={props?.name}>
                {props?.caption}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {(() => {
                  if (props?.data?.length > 0) {
                    return props?.data?.map((item, i) => {
                      return (
                        <div className="dropdown-menu-item" key={i}>
                          <Dropdown.Item data-test="dropdown-item" eventKey={item?.text}>
                            {/*  */}
                            <div
                              className="ic ic-country"
                              style={{
                                backgroundImage: `url(${item?.flagImage || DEFAULT_FLAG.src})`,
                              }}
                            >
                              <div className="text country-text">{item?.text}</div>
                            </div>
                          </Dropdown.Item>
                          {<Dropdown.Divider className="mx-3" />}
                        </div>
                      );
                    });
                  } else {
                    return (
                      <Dropdown.Item eventKey="1" className="noData">
                        No Data
                      </Dropdown.Item>
                    );
                  }
                })()}
              </Dropdown.Menu>
            </Dropdown>
          );
        } else if (props?.theme === 'sortDropDown') {
          return (
            <Dropdown onSelect={props.handleSelect}>
              <Dropdown.Toggle id="dropdown-custom-components" disabled={props?.disabled} name={props?.name}>
                {props?.caption}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {(() => {
                  if (props?.data?.length > 0) {
                    return props?.data?.map((item, i) => {
                      return (
                        <Dropdown.Item key={i} eventKey={item?.key}>
                          {item?.displayName}
                        </Dropdown.Item>
                      );
                    });
                  } else {
                    return (
                      <Dropdown.Item eventKey="1" className="noData">
                        No Data
                      </Dropdown.Item>
                    );
                  }
                })()}
              </Dropdown.Menu>
            </Dropdown>
          );
        } else {
          return props?.theme === 'userDropdown' ? (
            <Dropdown align={props?.align} className={props.theme} onSelect={props.handleSelect}>
              <Dropdown.Toggle data-test="dropdown" id="dropdown-custom-components" name={props?.name}>
                <span className="user-name" title={props.title ? `${props.caption}` : ''} data-sl="mask">
                  {props?.caption}
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {(() => {
                  if (props?.data?.length > 0) {
                    return props?.data?.map((item, i) => {
                      return (
                        <div className="dropdown-menu-item" key={i + item?.value}>
                          <Dropdown.Item
                            data-test="dropdown-item"
                            eventKey={item?.text}
                            onMouseEnter={() => setIsHover(i)}
                            onMouseLeave={() => setIsHover()}
                          >
                            <div className="ic">
                              <Image
                                className="dddddddddd"
                                src={isHover === i ? item?.iconHover : item?.icon}
                                layout="fill"
                                alt=""
                              />
                            </div>
                            <div className="text">{item?.text}</div>
                          </Dropdown.Item>
                          {item?.divider && <Dropdown.Divider />}
                        </div>
                      );
                    });
                  } else {
                    return (
                      <Dropdown.Item eventKey="1" className="noData">
                        No Data
                      </Dropdown.Item>
                    );
                  }
                })()}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <Dropdown className={props.theme} onSelect={props.handleSelect}>
              <Dropdown.Toggle id="dropdown-custom-components" disabled={props?.disabled} name={props?.name}>
                {props?.caption}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {(() => {
                  if (props?.data?.values?.length > 0) {
                    return props?.data?.values?.map((item, i) => {
                      return (
                        <Dropdown.Item key={i} eventKey={item}>
                          {item}
                        </Dropdown.Item>
                      );
                    });
                  } else {
                    return (
                      <Dropdown.Item eventKey="1" className="noData">
                        No Data
                      </Dropdown.Item>
                    );
                  }
                })()}
              </Dropdown.Menu>
            </Dropdown>
          );
        }
      })()}
    </DropdownStyled>
  );
};

DropdownControl.propTypes = {
  label: PropTypes.string,
  theme: PropTypes.string,
  enableFullWidth: PropTypes.bool,
  caption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.array,
  handleSelect: PropTypes.any,
  align: PropTypes.string,
  disabled: PropTypes.bool,
  renderDropdownItem: PropTypes.func,
  appVariant: PropTypes.string,
  title: PropTypes.bool,
  countryClass: PropTypes.string,
};

DropdownControl.defaultProps = {
  label: '',
  theme: '',
  enableFullWidth: false,
  caption: 'Select',
  data: [],
  align: '',
  disabled: false,
  title: false,
  countryClass: '',
};
export default DropdownControl;
